import { Component, OnInit, TemplateRef, ViewChild, ElementRef } from '@angular/core';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2'
import { BMApiService } from '../../../services/bm.service';
import { Router } from '@angular/router';
import { UserService } from '../../../services/user.service';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  MenuCallbackArgs,
  OnEventArgs,

} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { UtilityService } from '../../../services/utility.service';
import { AdminApiService } from '../../../services/admin.service';
import { tranbenchmarkkpi, tranbenchmarkkpihistory, benchmarkkpiposition, bmKPIPostionDashboard, year } from '../../../models/slakpi';
import { division, performancemaster } from '../../../models/admin';
import { HttpClient } from '@angular/common/http';
import { ToasterService } from '../../../toaster.service';
import { SLAKPIApiService } from '../../../services/slakpi.service';
declare var google: any;

@Component({
  selector: 'app-bench-mark-position',
  templateUrl: './bench-mark-position.component.html',
  styleUrls: ['./bench-mark-position.component.css']
})
export class BenchMarkPositionComponent implements OnInit {
  positionChartOption: {};
  
  public benchMarkYear_data: any;
  public currentHalf_data: any;
  public division_data: any;
  public BMposition_data: any;
  public gridApi: any;
  public gridColumnApi: any;
  public columnDefs: any;
  public defaultColDef: any;
  public rowData: any;
  public PopoverModule;
  //private viewtemplate: ElementRef;
  modalRef: BsModalRef;
  @ViewChild('viewtemplate', { static: false }) viewtemplate: TemplateRef<any>;
  columnDefinitions: Column[];
  gridOptions: GridOption;
  dataset: any;
  dataPositionSet: any;
  gridPositionOptions: GridOption;
  columnPositionDefinitions: Column[];
  yearfilter: any;
  divisionUnofilter: any;
  halffilter: any;
  positionfilter: any;
  angularGrid: AngularGridInstance;
  
  angularPositionGrid: AngularGridInstance;
  public TranKPI_data: any;
  public loading: boolean = true;
  public pageAction: string = 'add';
  public isStart: boolean = true;
  public isShowPostion: boolean = false;
  public filterDataCollectionCount: number = 0;
  public filterOverdueCount: number = 0;
  public filterCompletedCount: number = 0;
  public filterApprovalCount: number = 0;

  public filterAll_classactive: string = '';
  public filterDataCollection_classactive: string = 'active';
  public filterOverdue_classactive: string = '';
  public filterCompleted_classactive: string = '';
  public filterApproval_classactive: string = '';
  public tranBenchMarkKPIHistory_data: any;

  objTranBenchmarkKPI: any = new tranbenchmarkkpi();
  //for Users Default Value
  user: any = {};
  login_UserID: string; // number
  isAdmin: boolean;
  statusUno: number = 1;
  position_data: any;
  objKPIPostionDashboardList: any = [];
  objPeerList: any = [];
  selectedItem: any;
  currentYear: number;
  
 
  public isBMChampion: boolean = false;
  public isBMTeam: boolean = false;
  public isBMVisitor: boolean = false;
  public isBMAdmin: boolean = false;
  noDataImg: any;
  tenantUno: any;
  yearData: any;
  constructor(public http: HttpClient, public restApi: BMApiService, private toaster: ToasterService, public restAdminApi: AdminApiService, public utilityService: UtilityService, private router: Router, private spinner: SpinnerVisibilityService, private userService: UserService, private modalService: BsModalService, public restSLAKPIApi: SLAKPIApiService) {
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.noDataImg = this.utilityService.getnodataImage();
    this.tenantUno = this.user.tenantUno;
    this.ValidateUserAccess();
  }
  ValidateUserAccess() {
    

    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'BM Administrator') ? true : false;

    if (this.user.role == 'BM Champions')
      this.isBMChampion = true;
    if (this.user.role == 'BM Team')
      this.isBMTeam = true;
    if (this.user.role == 'BM Visitor')
      this.isBMVisitor = true;
    if (this.user.role == 'BM Administrator') { this.isBMAdmin = true; }

    if (!this.isAdmin) {
      let userPermissionData = this.userService.getUserRights("KPI Position");
      if (userPermissionData != null && userPermissionData != undefined && userPermissionData.length > 0) {
        if (userPermissionData[0].showPage == 1) {

        }
        else {
          this.router.navigateByUrl('/access-denied');
        }
      }
    }

  }

  
  ngOnInit() {
    this.userService.CheckLogin();
    let date = new Date();
    this.currentYear = Number(this.user.currentYear);//date.getFullYear();
    this.yearfilter = Number(this.user.currentYear);
    this.halffilter = Number(this.user.currentHalf);
    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };
    this.gridPositionOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };
    this.loadYear();
    //this.getBenchMarkYear();
    this.getDivisions();
    this.getcurrentHalf();
    this.LoadTranBenchmarkKPI('All');
    //this.loadBenckMarkKPIInboxCount();

    this.getPositionData();
    
  }

  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }

  angularPositionGridReady(angularGrid: AngularGridInstance) {
    this.angularPositionGrid = angularGrid;
    //this.userService.angularGrid = angularGrid;
  }
  loadYear() {

    let inpValue = new year();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    
    this.restSLAKPIApi.getYearMaster(inpValue)
      .subscribe(data => {
        
        this.yearData = data;

      },
        (error) => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }
  getBenchMarkYear() {
    
    let date = new Date();
    let pastYear = date.getFullYear() - 1;
    let currentYear = date.getFullYear();
    let futureYear = date.getFullYear() + 1;

    this.benchMarkYear_data = [
      { text: pastYear, value: pastYear },
      { text: currentYear, value: currentYear },
      { text: futureYear, value: futureYear }
    ];
  }
  getcurrentHalf() {
    

    this.currentHalf_data = [
      { text: 'First Half', value: 1 },
      { text: 'Second Half', value: 2 }
    ];
  }
  //getPositionData() {
  //  

  //  //this.position_data = [
  //  //  {text: 'Exceeding Peer', value: 1 },
  //  //  { text: 'Below Peer', value: 2 },
  //  //  { text: 'Top Quartile', value: 3 },
  //  //  { text: 'Median', value: 4 },
  //  //  { text: 'Similar Performance', value: 5 }
  //  //];
  //  this.position_data = [
  //    { text: 'Exceeding Peer', value: 1 },
  //    { text: 'Below Peer', value: 2 },
  //    { text: 'Bottom Quartile', value: 3 },
  //    { text: 'Median', value: 4 },
  //    { text: 'Top Quartile', value: 7 },
  //    { text: 'Similar Performance', value: 8 },
  //    { text: 'Top Decile', value: 9 }
  //  ];
  //}

  getPositionData() {
    this.spinner.show();
    let inpValue = new performancemaster();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.tenantUno = this.tenantUno;
    inpValue.condition = 1;
    inpValue.userUno = this.login_UserID;
    inpValue.tableName = 'position';

    this.restAdminApi.getPerformanceMaster(inpValue)
      .subscribe(data => {
        
        this.position_data = data;
 //else if (this.pfmType == "position") {
 //         mockDataset[i] = {
 //           id: this.data[i].id,
 //           titleNameEn: this.data[i].titleNameEn
 //         };
 //       }
     
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  getDivisions() {

    let inpValue = new division();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 5;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getDivisions(inpValue)
      .subscribe(data => {
        this.division_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }
  searchKPIPostion(filterByItem:string) {
    
    let temp = this;
    this.spinner.show();
    if (!this.isStart) {
      setTimeout(function () { temp.LoadTranBenchmarkKPI(filterByItem); }, 1000)

    }

  }



  LoadTranBenchmarkKPI(type:string) {
    
    this.loading = true;
    let currentYear = new Date().getFullYear();
    this.yearfilter = this.yearfilter ? this.yearfilter : currentYear;
    this.halffilter = this.halffilter ? this.halffilter : 1;
    this.divisionUnofilter = this.divisionUnofilter ? this.divisionUnofilter : 0;

    let inpValue = new tranbenchmarkkpi();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.userUno = this.login_UserID;
    inpValue.tenantUno = this.tenantUno;
    inpValue.statusUno = 5;
    inpValue.benchmarkYear = this.yearfilter;
    inpValue.kpiType = (this.halffilter == 1) ? 2 : 4;//this.halffilter;
    this.restApi.getTranBenchMarkKPIs(inpValue)
      .subscribe((data: any) => {
        
        let rtn_data = [];

        if (type == 'year')
          rtn_data = data.filter(x => x.benchmarkYear === this.yearfilter);
        else if (type == 'division' && this.divisionUnofilter >0)
          rtn_data = data.filter(x => x.businessDivisionUno === this.divisionUnofilter);
        else
          rtn_data = data.filter(x => x.benchmarkYear === this.yearfilter);
        const mockDataset = [];
        this.dataset = [];
        if (rtn_data != null && rtn_data.length > 0) {

           //uniqBy(data, 'kpiUno');
          
          for (let i = 0; i < rtn_data.length; i++) {

            let status = '';
            if (rtn_data[i].statusUno == '0')
              status = 'Released';
            else if (rtn_data[i].statusUno == '1')
              status = 'Data Entry';
            else if (rtn_data[i].statusUno == '2')
              status = 'Approval 1';
            else if (rtn_data[i].statusUno == '3')
              status = 'Approval 2';
            else if (rtn_data[i].statusUno == '4')
              status = 'Approval 3';
            else if (rtn_data[i].statusUno == '5')
              status = 'Completed';

           

            mockDataset[i] = {
              id: rtn_data[i].trnBenchmarkUno,
              kpiCode: rtn_data[i].kpiCode,
              kpiNameEn: rtn_data[i].kpiNameEn,
              dataOwnerName: rtn_data[i].dataOwnerName,
              dataOwnerUno: rtn_data[i].dataOwnerUno,
              level1ApproverUno: rtn_data[i].level1ApproverUno,
              level2ApproverUno: rtn_data[i].level2ApproverUno,
              level3ApproverUno: rtn_data[i].level3ApproverUno,
              targetValue: rtn_data[i].targetValue,
              actualValue: (rtn_data[i].actualValue == '') ? '-' : rtn_data[i].actualValue,
              kpiRule: rtn_data[i].kpiRule,
              rowType: rtn_data[i].rowType,
              isRelease: rtn_data[i].isRelease,
              statusUno: rtn_data[i].statusUno,
              status: status,
              benchmarkYear: rtn_data[i].benchmarkYear,
              positionUno: rtn_data[i].positionUno,
              businessDivisionUno: rtn_data[i].businessDivisionUno,
              kpiUno: rtn_data[i].kpiUno
            };
          }
          
          this.dataset = mockDataset;
          if (mockDataset.length > 0) {
            this.setColnDefn();
          }
          this.TranKPI_data = rtn_data;
         
          this.isStart = false;
          this.loading = false;
          this.spinner.hide()
        }
        else {
          this.dataset = [];
          this.isStart = false;
          this.loading = false;
          this.spinner.hide()
        }
      },
        (error) => {
          //Called when error.
          this.loading = false;
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  
  setColnDefn() {
    let temp = this;
    if (this.isBMChampion || this.isBMVisitor) {
      this.columnDefinitions = [
        {
          id: 'kpiCode', name: 'KPI Code', field: 'kpiCode', sortable: true,
          type: FieldType.string, filterable: true,
          filter: {
            collection: this.uniqueArray(this.dataset, 'kpiCode', 'kpiCode'),
            model: Filters.multipleSelect,
          }
        },
        {
          id: 'kpiNameEn', name: 'KPI', field: 'kpiNameEn', sortable: true, width: 300,
          type: FieldType.string, filterable: true,
          filter: {
            collection: this.uniqueArray(this.dataset, 'kpiNameEn', 'kpiNameEn'),
            model: Filters.multipleSelect,
          }
        },
        {
          id: 'dataOwnerName', name: 'Owner', field: 'dataOwnerName', sortable: true, width: 150,
          type: FieldType.string, filterable: true,
          filter: {
            collection: this.uniqueArray(this.dataset, 'dataOwnerName', 'dataOwnerName'),
            model: Filters.multipleSelect,
          }
        },
        {
          id: 'actualValue', name: 'Actual', field: 'actualValue', sortable: true, width: 50,
          type: FieldType.string, filterable: true,
          filter: {
            collection: this.uniqueArray(this.dataset, 'actualValue', 'actualValue'),
            model: Filters.multipleSelect,
          }
        },
        {
          id: 'targetValue', name: 'Target', field: 'targetValue', sortable: true,
          type: FieldType.string, filterable: true,
          filter: {
            collection: this.uniqueArray(this.dataset, 'targetValue', 'targetValue'),
            model: Filters.multipleSelect,
          }
        },
        //{
        //  id: 'kpiRule', name: 'KPI Rule', field: 'kpiRule', sortable: true,
        //  type: FieldType.string, filterable: true,
        //  filter: {
        //    collection: this.uniqueArray(this.dataset, 'kpiRule', 'kpiRule'),
        //    model: Filters.multipleSelect,
        //  }
        //},
        //{
        //  id: 'rowType', name: 'Row Type', field: 'rowType', sortable: true,
        //  type: FieldType.string, filterable: true,
        //  filter: {
        //    collection: this.uniqueArray(this.dataset, 'rowType', 'rowType'),
        //    model: Filters.multipleSelect,
        //  }
        //},
        {
          id: 'status', name: 'Status', field: 'status', sortable: true,
          type: FieldType.string, filterable: true,
          formatter: (row, cell, val, columnDef, data) => {
            if (data.statusUno == '5')
              return '<span  class="status-area status-green">Completed</span>';
          },
          filter: {
            collection: this.uniqueArray(this.dataset, 'status', 'status'),
            model: Filters.multipleSelect,
          }
        }

      ]
    }
    else {
      this.columnDefinitions = [
        {
          id: 'kpiCode', name: 'KPI Code', field: 'kpiCode', sortable: true,
          type: FieldType.string, filterable: true,
          filter: {
            collection: this.uniqueArray(this.dataset, 'kpiCode', 'kpiCode'),
            model: Filters.multipleSelect,
          }
        },
        {
          id: 'kpiNameEn', name: 'KPI', field: 'kpiNameEn', sortable: true, width: 300,
          type: FieldType.string, filterable: true,
          filter: {
            collection: this.uniqueArray(this.dataset, 'kpiNameEn', 'kpiNameEn'),
            model: Filters.multipleSelect,
          }
        },
        {
          id: 'dataOwnerName', name: 'Owner', field: 'dataOwnerName', sortable: true, width: 150,
          type: FieldType.string, filterable: true,
          filter: {
            collection: this.uniqueArray(this.dataset, 'dataOwnerName', 'dataOwnerName'),
            model: Filters.multipleSelect,
          }
        },
        {
          id: 'actualValue', name: 'Actual', field: 'actualValue', sortable: true, width: 50,
          type: FieldType.string, filterable: true,
          filter: {
            collection: this.uniqueArray(this.dataset, 'actualValue', 'actualValue'),
            model: Filters.multipleSelect,
          }
        },
        {
          id: 'targetValue', name: 'Target', field: 'targetValue', sortable: true,
          type: FieldType.string, filterable: true,
          filter: {
            collection: this.uniqueArray(this.dataset, 'targetValue', 'targetValue'),
            model: Filters.multipleSelect,
          }
        },
        //{
        //  id: 'kpiRule', name: 'KPI Rule', field: 'kpiRule', sortable: true,
        //  type: FieldType.string, filterable: true,
        //  filter: {
        //    collection: this.uniqueArray(this.dataset, 'kpiRule', 'kpiRule'),
        //    model: Filters.multipleSelect,
        //  }
        //},
        //{
        //  id: 'rowType', name: 'Row Type', field: 'rowType', sortable: true,
        //  type: FieldType.string, filterable: true,
        //  filter: {
        //    collection: this.uniqueArray(this.dataset, 'rowType', 'rowType'),
        //    model: Filters.multipleSelect,
        //  }
        //},
        {
          id: 'status', name: 'Status', field: 'status', sortable: true,
          type: FieldType.string, filterable: true,
          formatter: (row, cell, val, columnDef, data) => {
            if (data.statusUno == '5')
              return '<span  class="status-area status-green">Completed</span>';
          },
          filter: {
            collection: this.uniqueArray(this.dataset, 'status', 'status'),
            model: Filters.multipleSelect,
          }
        },
        {
          id: 'action', name: 'Action', field: 'action', width: 50, cssClass: 'blue',
          type: FieldType.string, formatter: (row, cell, val, columnDef, data) => { return '<span style="cursor:pointer"><i class="fa fa-pencil-square-o fa-lg"></i></span>'; },
          onCellClick: (e: Event, args: OnEventArgs) => {
            this.pageAction = 'view';
            let rdata: any = args.dataContext;
            this.selectedItem = rdata;
            
            this.isShowPostion = false;
            if (rdata.positionUno == 0) {
              this.isShowPostion = true;
            }
            //this.kpiUno = rdata.kpiUno;
            this.getKPIPostionDashboardList();
            this.getKPIPostion(rdata.id);
            //this.getViewHistory(rdata.id);
            //this.router.navigateByUrl('/benchmarkkpiview/' + rdata.id);
            

            //google.charts.load('current', { 'packages': ['corechart'] });
            //google.charts.setOnLoadCallback(this.benchmarkpositionmodalchart);



            this.modalRef = this.modalService.show(
              this.viewtemplate,
              Object.assign({}, {
                class: 'gray modal-xl',
                backdrop: true,
                keyboard: true,
                focus: true,
                show: false,
                ignoreBackdropClick: true,
                animated: true
              })
            );
          }
        }

        //,{
        //  id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 50,
        //  excludeFromExport: true,
        //  formatter: this.actionFormatter,
        //  cellMenu: {
        //    hideCloseButton: false,
        //    commandTitleKey: 'COMMANDS',
        //    commandItems: [

        //      {
        //        command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'KPI Position',
        //        itemVisibilityOverride: (args: MenuCallbackArgs) => {
        //          let data = args.dataContext;

        //          if (this.isBMChampion || this.isBMVisitor)
        //            return false;
        //          else return true;
        //        },
        //        iconCssClass: 'fa fa-lg fa-info-circle', cssClass: 'blue', textCssClass: 'bold',

        //        action: (e, args) => {
        //          this.pageAction = 'view';
        //          let rdata: any = args.dataContext;
        //          this.selectedItem = rdata;
        //          
        //          this.isShowPostion = false;
        //          if (rdata.positionUno == 0) {
        //            this.isShowPostion = true;
        //          }
        //          //this.kpiUno = rdata.kpiUno;
        //          this.getKPIPostion(rdata.kpiUno);
        //          //this.getViewHistory(rdata.id);
        //          //this.router.navigateByUrl('/benchmarkkpiview/' + rdata.id);
        //          this.getKPIPostionDashboardList();

        //          //google.charts.load('current', { 'packages': ['corechart'] });
        //          //google.charts.setOnLoadCallback(this.benchmarkpositionmodalchart);



        //          this.modalRef = this.modalService.show(
        //            this.viewtemplate,
        //            Object.assign({}, {
        //              class: 'gray modal-lg',
        //              backdrop: true,
        //              keyboard: true,
        //              focus: true,
        //              show: false,
        //              ignoreBackdropClick: true,
        //              animated: true
        //            })
        //          );

        //        },
        //      //  // only show command to 'Delete Row' when the task is not completed

        //     },
        //      { divider: true, command: '', positionOrder: 63 },



        //    ],
        //  }
        //}




      ]
    }

  }
  getKPIPostion(kpiUno:number) {
    
    let inpValue = new benchmarkkpiposition();
    inpValue.userUno = this.login_UserID;
    inpValue.kpiUno = kpiUno;
    inpValue.condition = 1;
    this.restApi.getBenchMarkKPIPosition(inpValue)
      .subscribe(data => {
        
        this.BMposition_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }
  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
  };
  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val;
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' '

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val.trim()
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' '

  }

  onupdateKPIPosition() {
    

    if (this.positionfilter != null) {
      let position = this.position_data.filter(item => item.id == this.positionfilter);

      let posionName = (position != null) ? position[0].titleNameEn : "";

      let objPosition = new benchmarkkpiposition();
      objPosition.trnKPIUno = this.selectedItem.id;
      objPosition.year = this.selectedItem.benchmarkYear;
      objPosition.positionUno = this.positionfilter;
      objPosition.positionName = posionName;
      objPosition.userUno = this.login_UserID;
      this.restApi.addEditBenchMarkKPIPosition(objPosition)
        .subscribe(data => {

          if (data != null && data != undefined && data != '') {
           // Swal.fire('Error', 'Something went wrong', 'error');
            this.toaster.show('error', 'Error', 'Something went wrong.');
            this.spinner.hide();
          }
          else {
            //Swal.fire({
            //  type: 'success',
            //  title: 'BenchMark KPI Position Updated',
            //  showConfirmButton: false,
            //  timer: 1500
            //})
            this.toaster.show('success', 'Success', 'BenchMark KPI position updated.');
            this.modalRef.hide();
            setTimeout(() => {
              this.spinner.hide();
              this.LoadTranBenchmarkKPI('All');
            }, 900);

          }



        },
          (error) => {
            //Called when error
            this.spinner.hide();
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
          //this.spinner.hide();
        });
    }
    else {}
    



    //benchmarkYear

    //addEditBenchMarkKPIPosition
    
  }
  getKPIPostionDashboardList() {
    
    let inpValue = new bmKPIPostionDashboard();
    //inpValue.organization = '';
    //inpValue.division = this.divisionUnofilter ? this.divisionUnofilter : 0;
    inpValue.year = this.currentYear;//this.yearfilter ? this.yearfilter : 0;
    //inpValue.quarter = this.quarterfilter ? this.quarterfilter : 0;
    inpValue.kpiuno = this.selectedItem.kpiUno;
    inpValue.userUno = this.login_UserID;
    this.restApi.getBMPostionDashboard(inpValue)
      .subscribe(data => {
        
        if (data != null) {
          this.objKPIPostionDashboardList = data;
          this.objPeerList = this.objKPIPostionDashboardList.peerData;

          const mockDataset = [];
          for (let i = 0; i < this.objPeerList.length; i++) {


            mockDataset[i] = {
              id: i + 1,
              peerName: this.objPeerList[i].peerName,
              column1: (this.objPeerList[i].column1 != null) ? this.objPeerList[i].column1:"-",
              column2: (this.objPeerList[i].column2 != null) ? this.objPeerList[i].column2 : "-",
              column3: (this.objPeerList[i].column3 != null) ? this.objPeerList[i].column3 : "-",
              column4: (this.objPeerList[i].column4 != null) ? this.objPeerList[i].column4 : "-",
              column5: (this.objPeerList[i].column5 != null) ? this.objPeerList[i].column5 : "-"
            };
          }
          
          this.dataPositionSet = mockDataset;        
          this.setPositionDefn();

          if (this.objKPIPostionDashboardList.distinctPeerData.length > 0 && this.objKPIPostionDashboardList.peerDataChart.length > 1) {
            this.spinner.show();
            setTimeout(() => {
              //google.charts.load('current', { 'packages': ['corechart'] });
              //google.charts.setOnLoadCallback(this.benchmarkpositionmodalchart(this.objKPIPostionDashboardList.peerDataChart, this.objKPIPostionDashboardList.distinctPeerData));

              this.benchmarkpositionmodalchart(this.objKPIPostionDashboardList.peerDataChart, this.objKPIPostionDashboardList.distinctPeerData);
              this.spinner.hide();
            }, 700);
          }                 

        }

        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });


  }
  setPositionDefn() {
    let col1Name:any = Number(this.currentYear) - 4;
    let col2Name:any = Number(this.currentYear) - 3;
    let col3Name:any = Number(this.currentYear) - 2;
    let col4Name:any = Number(this.currentYear) - 1;
    let col5Name: any = Number(this.currentYear);
    this.columnPositionDefinitions = [
      { id: 'peerName', name: 'Peer', field: 'peerName', sortable: true },
      { id: 'column1', name: col1Name, field: 'column1', sortable: true },
      { id: 'column2', name: col2Name, field: 'column2', sortable: true },
      { id: 'column3', name: col3Name, field: 'column3', sortable: true },
      { id: 'column4', name: col4Name, field: 'column4', sortable: true },
      { id: 'column5', name: col5Name, field: 'column5', sortable: true },


    ];
  }

  benchmarkpositionmodalchart = (option_data: any, distinctdata: any) => {
    
    //const data = google.visualization.arrayToDataTable([
    //  ['Month', 'Top Decile', 'Top Quartile', 'Average', 'Median', 'Top Quartile'],
    //  ['2004/05', 1165, 938, 900, 2000, 2500],
    //  ['2005/06', 1135, 820, 700, 1800, 1900],
    //  ['2006/07', 2157, 1167, 1000, 2250, 2500],
    //  ['2007/08', 2139, 1110, 1100, 2500, 2600],
    //  ['2008/09', 1136, 691, 500, 1700, 2000]

    //]);

    //const data = google.visualization.arrayToDataTable([
    //  ['Year', 'Actual', 'Target', 'Peer1', 'Peer2', 'Peer3'],
    //  [2020, 70, 90, 50, 0, 70],
    //  [2021, 55, 90, 60, 70, 0]
    //  //['2022', 70, 90, 0, 60, 80]
    //  //['2004/06', 1135, 820, 0, 1800, 0],
    //  //['2006/07', 2157, 1167, 0, 0, 2500],
    //  //['2007/08', 2139, 1110, 1100, 2500, 2600],
    //  //['2008/09', 1136, 691, 500, 1700, 2000]

    //]);
    // let tempArray = [];
    // if (distinctdata.length > 0 && option_data.length > 1) {

    //     var distinctCount = distinctdata.length;
    //   if (distinctCount == 1)
    //       tempArray.push(['Year', 'Actual', 'Target', option_data[0].column1]);
    //   if (distinctCount == 2)
    //       tempArray.push(['Year', 'Actual', 'Target', option_data[0].column1, option_data[0].column2]);
    //   if (distinctCount == 3)
    //       tempArray.push(['Year', 'Actual', 'Target', option_data[0].column1, option_data[0].column2, option_data[0].column3]);
    //   if (distinctCount == 4)
    //       tempArray.push(['Year', 'Actual', 'Target', option_data[0].column1, option_data[0].column2, option_data[0].column3, option_data[0].column4]);
    //   if (distinctCount == 5)
    //       tempArray.push(['Year', 'Actual', 'Target', option_data[0].column1, option_data[0].column2, option_data[0].column3, option_data[0].column4, option_data[0].column5]);
    //   if (distinctCount == 6)
    //       tempArray.push(['Year', 'Actual', 'Target', option_data[0].column1, option_data[0].column2, option_data[0].column3, option_data[0].column4, option_data[0].column5, option_data[0].column6]);
    //   if (distinctCount == 7)
    //       tempArray.push(['Year', 'Actual', 'Target', option_data[0].column1, option_data[0].column2, option_data[0].column3, option_data[0].column4, option_data[0].column5, option_data[0].column6, option_data[0].column7]);
    //   if (distinctCount == 8)
    //       tempArray.push(['Year', 'Actual', 'Target', option_data[0].column1, option_data[0].column2, option_data[0].column3, option_data[0].column4, option_data[0].column5, option_data[0].column6, option_data[0].column7, option_data[0].column8]);
    //   if (distinctCount == 9)
    //       tempArray.push(['Year', 'Actual', 'Target', option_data[0].column1, option_data[0].column2, option_data[0].column3, option_data[0].column4, option_data[0].column5, option_data[0].column6, option_data[0].column7, option_data[0].column8, option_data[0].column9]);
    //   if (distinctCount == 10)
    //       tempArray.push(['Year', 'Actual', 'Target', option_data[0].column1, option_data[0].column2, option_data[0].column3, option_data[0].column4, option_data[0].column5, option_data[0].column6, option_data[0].column7, option_data[0].column8, option_data[0].column9, option_data[0].column10]);
    //   if (distinctCount == 11)
    //       tempArray.push(['Year', 'Actual', 'Target', option_data[0].column1, option_data[0].column2, option_data[0].column3, option_data[0].column4, option_data[0].column5, option_data[0].column6, option_data[0].column7, option_data[0].column8, option_data[0].column9, option_data[0].column10, option_data[0].column11]);
    //   if (distinctCount == 12)
    //       tempArray.push(['Year', 'Actual', 'Target', option_data[0].column1, option_data[0].column2, option_data[0].column3, option_data[0].column4, option_data[0].column5, option_data[0].column6, option_data[0].column7, option_data[0].column8, option_data[0].column9, option_data[0].column10, option_data[0].column11, option_data[0].column12]);
    //   if (distinctCount == 13)
    //       tempArray.push(['Year', 'Actual', 'Target', option_data[0].column1, option_data[0].column2, option_data[0].column3, option_data[0].column4, option_data[0].column5, option_data[0].column6, option_data[0].column7, option_data[0].column8, option_data[0].column9, option_data[0].column10, option_data[0].column11, option_data[0].column12, option_data[0].column13]);
    //   if (distinctCount == 14)
    //       tempArray.push(['Year', 'Actual', 'Target', option_data[0].column1, option_data[0].column2, option_data[0].column3, option_data[0].column4, option_data[0].column5, option_data[0].column6, option_data[0].column7, option_data[0].column8, option_data[0].column9, option_data[0].column10, option_data[0].column11, option_data[0].column12, option_data[0].column13, option_data[0].column14]);
    //   if (distinctCount == 15)
    //       tempArray.push(['Year', 'Actual', 'Target', option_data[0].column1, option_data[0].column2, option_data[0].column3, option_data[0].column4, option_data[0].column5, option_data[0].column6, option_data[0].column7, option_data[0].column8, option_data[0].column9, option_data[0].column10, option_data[0].column11, option_data[0].column12, option_data[0].column13, option_data[0].column14, option_data[0].column15]);


    //   for (var i = 0; i < option_data.length; i++) {
    //     if (i > 0) {
    //       if (distinctCount == 1)
    //         tempArray.push([option_data[i].year, parseInt(option_data[i].actualValue), parseInt(option_data[i].targetValue), parseInt(option_data[i].column1)]);
    //       if (distinctCount == 2)
    //         tempArray.push([option_data[i].year, parseInt(option_data[i].actualValue), parseInt(option_data[i].targetValue), parseInt(option_data[i].column1), parseInt(option_data[i].column2)]);
    //       if (distinctCount == 3)
    //         tempArray.push([option_data[i].year, parseInt(option_data[i].actualValue), parseInt(option_data[i].targetValue), parseInt(option_data[i].column1), parseInt(option_data[i].column2), parseInt(option_data[i].column3)]);
    //       if (distinctCount == 4)
    //         tempArray.push([option_data[i].year, parseInt(option_data[i].actualValue), parseInt(option_data[i].targetValue), parseInt(option_data[i].column1), parseInt(option_data[i].column2), parseInt(option_data[i].column3), parseInt(option_data[i].column4)]);
    //       if (distinctCount == 5)
    //         tempArray.push([option_data[i].year, parseInt(option_data[i].actualValue), parseInt(option_data[i].targetValue), parseInt(option_data[i].column1), parseInt(option_data[i].column2), parseInt(option_data[i].column3), parseInt(option_data[i].column4), parseInt(option_data[i].column5)]);
    //       if (distinctCount == 6)
    //         tempArray.push([option_data[i].year, parseInt(option_data[i].actualValue), parseInt(option_data[i].targetValue), parseInt(option_data[i].column1), parseInt(option_data[i].column2), parseInt(option_data[i].column3), parseInt(option_data[i].column4), parseInt(option_data[i].column5), parseInt(option_data[i].column6)]);
    //       if (distinctCount == 7)
    //         tempArray.push([option_data[i].year, parseInt(option_data[i].actualValue), parseInt(option_data[i].targetValue), parseInt(option_data[i].column1), parseInt(option_data[i].column2), parseInt(option_data[i].column3), parseInt(option_data[i].column4), parseInt(option_data[i].column5), parseInt(option_data[i].column6), parseInt(option_data[i].column7)]);
    //       if (distinctCount == 8)
    //         tempArray.push([option_data[i].year, parseInt(option_data[i].actualValue), parseInt(option_data[i].targetValue), parseInt(option_data[i].column1), parseInt(option_data[i].column2), parseInt(option_data[i].column3), parseInt(option_data[i].column4), parseInt(option_data[i].column5), parseInt(option_data[i].column6), parseInt(option_data[i].column7), parseInt(option_data[i].column8)]);
    //       if (distinctCount == 9)
    //         tempArray.push([option_data[i].year, parseInt(option_data[i].actualValue), parseInt(option_data[i].targetValue), parseInt(option_data[i].column1), parseInt(option_data[i].column2), parseInt(option_data[i].column3), parseInt(option_data[i].column4), parseInt(option_data[i].column5), parseInt(option_data[i].column6), parseInt(option_data[i].column7), parseInt(option_data[i].column8), parseInt(option_data[i].column9)]);
    //       if (distinctCount == 10)
    //         tempArray.push([option_data[i].year, parseInt(option_data[i].actualValue), parseInt(option_data[i].targetValue), parseInt(option_data[i].column1), parseInt(option_data[i].column2), parseInt(option_data[i].column3), parseInt(option_data[i].column4), parseInt(option_data[i].column5), parseInt(option_data[i].column6), parseInt(option_data[i].column7), parseInt(option_data[i].column8), parseInt(option_data[i].column9), parseInt(option_data[i].column10)]);
    //       if (distinctCount == 11)
    //         tempArray.push([option_data[i].year, parseInt(option_data[i].actualValue), parseInt(option_data[i].targetValue), parseInt(option_data[i].column1), parseInt(option_data[i].column2), parseInt(option_data[i].column3), parseInt(option_data[i].column4), parseInt(option_data[i].column5), parseInt(option_data[i].column6), parseInt(option_data[i].column7), parseInt(option_data[i].column8), parseInt(option_data[i].column9), parseInt(option_data[i].column10), parseInt(option_data[i].column11)]);
    //       if (distinctCount == 12)
    //         tempArray.push([option_data[i].year, parseInt(option_data[i].actualValue), parseInt(option_data[i].targetValue), parseInt(option_data[i].column1), parseInt(option_data[i].column2), parseInt(option_data[i].column3), parseInt(option_data[i].column4), parseInt(option_data[i].column5), parseInt(option_data[i].column6), parseInt(option_data[i].column7), parseInt(option_data[i].column8), parseInt(option_data[i].column9), parseInt(option_data[i].column10), parseInt(option_data[i].column11), parseInt(option_data[i].column12)]);
    //       if (distinctCount == 13)
    //         tempArray.push([option_data[i].year, parseInt(option_data[i].actualValue), parseInt(option_data[i].targetValue), parseInt(option_data[i].column1), parseInt(option_data[i].column2), parseInt(option_data[i].column3), parseInt(option_data[i].column4), parseInt(option_data[i].column5), parseInt(option_data[i].column6), parseInt(option_data[i].column7), parseInt(option_data[i].column8), parseInt(option_data[i].column9), parseInt(option_data[i].column10), parseInt(option_data[i].column11), parseInt(option_data[i].column12), parseInt(option_data[i].column13)]);
    //       if (distinctCount == 14)
    //         tempArray.push([option_data[i].year, parseInt(option_data[i].actualValue), parseInt(option_data[i].targetValue), parseInt(option_data[i].column1), parseInt(option_data[i].column2), parseInt(option_data[i].column3), parseInt(option_data[i].column4), parseInt(option_data[i].column5), parseInt(option_data[i].column6), parseInt(option_data[i].column7), parseInt(option_data[i].column8), parseInt(option_data[i].column9), parseInt(option_data[i].column10), parseInt(option_data[i].column11), parseInt(option_data[i].column12), parseInt(option_data[i].column13), parseInt(option_data[i].column14)]);
    //       if (distinctCount == 15)
    //         tempArray.push([option_data[i].year, parseInt(option_data[i].actualValue), parseInt(option_data[i].targetValue), parseInt(option_data[i].column1), parseInt(option_data[i].column2), parseInt(option_data[i].column3), parseInt(option_data[i].column4), parseInt(option_data[i].column5), parseInt(option_data[i].column6), parseInt(option_data[i].column7), parseInt(option_data[i].column8), parseInt(option_data[i].column9), parseInt(option_data[i].column10), parseInt(option_data[i].column11), parseInt(option_data[i].column12), parseInt(option_data[i].column13), parseInt(option_data[i].column14), parseInt(option_data[i].column15)]);
    //     }
    //   }
    // }

    //const data = new google.visualization.arrayToDataTable(tempArray);

    // const options = {
    //   title: 'DEWA Benchmarking position categories against peers',
    //   vAxis: { title: 'Name' },
    //   hAxis: { title: 'Year' },
    //   seriesType: 'bars',

    //   bar: {
    //     groupWidth: '40%'
    //   },


    //   legend: { position: 'top' },
    //   chartArea: { left: 10, top: 50, bottom: 10, width: "100%", height: "100%" },
    //   series: {
    //     0: { color: '#04bdae' },
    //     1: { color: '#367cd2' },
    //     2: { type: 'line', color: '#404041' },
    //     3: { type: 'line', color: '#68b080' },
    //     4: { type: 'line', color: '#d5d5d5' },
    //     5: { type: 'line', color: '#0b937e' },
    //   },
    // };

    // const chart = new google.visualization.ComboChart(document.getElementById('benchmarkpositionmodalchart'));
    // chart.draw(data, options);
    let LegendArray = [];
    
    if (distinctdata.length > 0 && option_data.length > 1) {

      var distinctCount = distinctdata.length;
      if (distinctCount == 1)
        LegendArray.push(['Year', 'Actual', 'Target', option_data[0].column1]);
      if (distinctCount == 2)
        LegendArray.push(['Year', 'Actual', 'Target', option_data[0].column1, option_data[0].column2]);
      if (distinctCount == 3)
        LegendArray.push(['Year', 'Actual', 'Target', option_data[0].column1, option_data[0].column2, option_data[0].column3]);
      if (distinctCount == 4)
        LegendArray.push(['Year', 'Actual', 'Target', option_data[0].column1, option_data[0].column2, option_data[0].column3, option_data[0].column4]);
      if (distinctCount == 5)
        LegendArray.push(['Year', 'Actual', 'Target', option_data[0].column1, option_data[0].column2, option_data[0].column3, option_data[0].column4, option_data[0].column5]);
      if (distinctCount == 6)
        LegendArray.push(['Year', 'Actual', 'Target', option_data[0].column1, option_data[0].column2, option_data[0].column3, option_data[0].column4, option_data[0].column5, option_data[0].column6]);
      if (distinctCount == 7)
        LegendArray.push(['Year', 'Actual', 'Target', option_data[0].column1, option_data[0].column2, option_data[0].column3, option_data[0].column4, option_data[0].column5, option_data[0].column6, option_data[0].column7]);
      if (distinctCount == 8)
        LegendArray.push(['Year', 'Actual', 'Target', option_data[0].column1, option_data[0].column2, option_data[0].column3, option_data[0].column4, option_data[0].column5, option_data[0].column6, option_data[0].column7, option_data[0].column8]);
      if (distinctCount == 9)
        LegendArray.push(['Year', 'Actual', 'Target', option_data[0].column1, option_data[0].column2, option_data[0].column3, option_data[0].column4, option_data[0].column5, option_data[0].column6, option_data[0].column7, option_data[0].column8, option_data[0].column9]);
      if (distinctCount == 10)
        LegendArray.push(['Year', 'Actual', 'Target', option_data[0].column1, option_data[0].column2, option_data[0].column3, option_data[0].column4, option_data[0].column5, option_data[0].column6, option_data[0].column7, option_data[0].column8, option_data[0].column9, option_data[0].column10]);
      if (distinctCount == 11)
        LegendArray.push(['Year', 'Actual', 'Target', option_data[0].column1, option_data[0].column2, option_data[0].column3, option_data[0].column4, option_data[0].column5, option_data[0].column6, option_data[0].column7, option_data[0].column8, option_data[0].column9, option_data[0].column10, option_data[0].column11]);
      if (distinctCount == 12)
        LegendArray.push(['Year', 'Actual', 'Target', option_data[0].column1, option_data[0].column2, option_data[0].column3, option_data[0].column4, option_data[0].column5, option_data[0].column6, option_data[0].column7, option_data[0].column8, option_data[0].column9, option_data[0].column10, option_data[0].column11, option_data[0].column12]);
      if (distinctCount == 13)
        LegendArray.push(['Year', 'Actual', 'Target', option_data[0].column1, option_data[0].column2, option_data[0].column3, option_data[0].column4, option_data[0].column5, option_data[0].column6, option_data[0].column7, option_data[0].column8, option_data[0].column9, option_data[0].column10, option_data[0].column11, option_data[0].column12, option_data[0].column13]);
      if (distinctCount == 14)
        LegendArray.push(['Year', 'Actual', 'Target', option_data[0].column1, option_data[0].column2, option_data[0].column3, option_data[0].column4, option_data[0].column5, option_data[0].column6, option_data[0].column7, option_data[0].column8, option_data[0].column9, option_data[0].column10, option_data[0].column11, option_data[0].column12, option_data[0].column13, option_data[0].column14]);
      if (distinctCount == 15)
        LegendArray.push(['Year', 'Actual', 'Target', option_data[0].column1, option_data[0].column2, option_data[0].column3, option_data[0].column4, option_data[0].column5, option_data[0].column6, option_data[0].column7, option_data[0].column8, option_data[0].column9, option_data[0].column10, option_data[0].column11, option_data[0].column12, option_data[0].column13, option_data[0].column14, option_data[0].column15]);



      //for (var i = 0; i < option_data.length; i++) {
      //     if (i > 0) {
      //       if (distinctCount == 1)
      //         tempArray.push([option_data[i].year, parseInt(option_data[i].actualValue), parseInt(option_data[i].targetValue), parseInt(option_data[i].column1)]);
      //}

      let yearArray = [];
      let actualArray = [];
      let targetArray = [];
      
      let peer1Array = [];
      let peer2Array = [];
      let peer3Array = [];
      let peer4Array = [];
      let peer5Array = [];
      let peer6Array = [];
      let peer7Array = [];
      let peer8Array = [];
      let peer9Array = [];
      let peer10Array = [];
      let peer11Array = [];
      let peer12Array = [];
      let peer13Array = [];
      let peer14Array = [];
      let peer15Array = [];

      let seriesArray = [];
      
       
      for (var i = 0; i < option_data.length; i++) {
        if (i > 0) {
          let yearName = option_data[i].year;
          let actualValue = parseInt(option_data[i].actualValue);
          let targetValue = parseInt(option_data[i].targetValue);
          //distinctCount
          yearArray.push(yearName);
          actualArray.push(actualValue);
          targetArray.push(targetValue);
          

          //seriesArray.push({ name: option_data[0].column1,type: 'line',yAxisIndex: 1,data: peerArray});

          //if (distinctCount == 1) {
          //  peerArray[0].push(parseInt(option_data[i].column1));
          //}
          //if (distinctCount == 2) {
          //  peerArray[0].push(parseInt(option_data[i].column1));
          //  peerArray[1].push(parseInt(option_data[i].column1));
          //}

          for (var j = 0; j < distinctCount; j++) {

            if (j == 0) { peer1Array.push(parseInt(option_data[i].column1)); }
            if (j == 1) { peer2Array.push(parseInt(option_data[i].column2)); }
            if (j == 2) { peer3Array.push(parseInt(option_data[i].column3)); }
            if (j == 3) { peer4Array.push(parseInt(option_data[i].column4)); }
            if (j == 4) { peer5Array.push(parseInt(option_data[i].column5)); }
            if (j == 5) { peer6Array.push(parseInt(option_data[i].column6)); }
            if (j == 6) { peer7Array.push(parseInt(option_data[i].column7)); }
            if (j == 7) { peer8Array.push(parseInt(option_data[i].column8)); }
            if (j == 8) { peer9Array.push(parseInt(option_data[i].column9)); }
            if (j == 9) { peer10Array.push(parseInt(option_data[i].column10)); }
            if (j == 10) { peer11Array.push(parseInt(option_data[i].column11)); }
            if (j == 11) { peer12Array.push(parseInt(option_data[i].column12)); }
            if (j == 12) { peer13Array.push(parseInt(option_data[i].column13)); }
            if (j == 13) { peer14Array.push(parseInt(option_data[i].column14)); }
            if (j == 14) { peer15Array.push(parseInt(option_data[i].column15)); }
          }
         
        }
      }
      seriesArray.push({ name: 'Actual', type: 'bar', data: actualArray });
      seriesArray.push({ name: 'Target', type: 'bar', data: targetArray });

      

      if (peer1Array != null && peer1Array.length > 0) {
        seriesArray.push({ name: option_data[0].column1, type: 'line', yAxisIndex: 1, data: peer1Array });
      }
      if (peer2Array != null && peer2Array.length > 0) {
        seriesArray.push({ name: option_data[0].column2, type: 'line', yAxisIndex: 1, data: peer2Array });
      }
      if (peer3Array != null && peer3Array.length > 0) {
        seriesArray.push({ name: option_data[0].column3, type: 'line', yAxisIndex: 1, data: peer3Array });
      }
      if (peer4Array != null && peer4Array.length > 0) {
        seriesArray.push({ name: option_data[0].column4, type: 'line', yAxisIndex: 1, data: peer4Array });
      }
      if (peer5Array != null && peer5Array.length > 0) {
        seriesArray.push({ name: option_data[0].column5, type: 'line', yAxisIndex: 1, data: peer5Array });
      }


      if (peer6Array != null && peer6Array.length > 0) {
        seriesArray.push({ name: option_data[0].column6, type: 'line', yAxisIndex: 1, data: peer6Array });
      }
      if (peer7Array != null && peer7Array.length > 0) {
        seriesArray.push({ name: option_data[0].column7, type: 'line', yAxisIndex: 1, data: peer7Array });
      }
      if (peer8Array != null && peer8Array.length > 0) {
        seriesArray.push({ name: option_data[0].column8, type: 'line', yAxisIndex: 1, data: peer8Array });
      }
      if (peer9Array != null && peer9Array.length > 0) {
        seriesArray.push({ name: option_data[0].column9, type: 'line', yAxisIndex: 1, data: peer9Array });
      }
      if (peer10Array != null && peer10Array.length > 0) {
        seriesArray.push({ name: option_data[0].column10, type: 'line', yAxisIndex: 1, data: peer10Array });
      }

      if (peer11Array != null && peer11Array.length > 0) {
        seriesArray.push({ name: option_data[0].column11, type: 'line', yAxisIndex: 1, data: peer11Array });
      }
      if (peer12Array != null && peer12Array.length > 0) {
        seriesArray.push({ name: option_data[0].column12, type: 'line', yAxisIndex: 1, data: peer12Array });
      }
      if (peer13Array != null && peer13Array.length > 0) {
        seriesArray.push({ name: option_data[0].column13, type: 'line', yAxisIndex: 1, data: peer13Array });
      }
      if (peer14Array != null && peer14Array.length > 0) {
        seriesArray.push({ name: option_data[0].column14, type: 'line', yAxisIndex: 1, data: peer14Array });
      }
      if (peer15Array != null && peer15Array.length > 0) {
        seriesArray.push({ name: option_data[0].column15, type: 'line', yAxisIndex: 1, data: peer15Array });
      }

      
      
      


      let legendData = LegendArray;//['Actual', 'Target', 'Peer1'];

      let YearData = yearArray;//['2021','2022','2023']

      
      this.positionChartOption = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            },
            
          },
          position: [10,0]
        },
        toolbox: {
          feature: {
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ['line', 'bar'] },
            restore: { show: true },
            saveAsImage: { show: true },
           
          }
        },
        legend: {
          data: legendData
        },
        color: ['#68b097', '#9e9e9e', '#04bdae'],
        xAxis: [
          {
            type: 'category',
            data: YearData,
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '',
            min: 0,

            axisLabel: {
              formatter: '{value}'
            }
          },
          {
            type: 'value',
            name: '',
            min: 0,

            axisLabel: {
              formatter: ''
            }
          }
        ],
        series: seriesArray
      };

    }
  }
  
}
